import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface UpdateUserProfileParams {
  userId: string;
  firstName: string;
  lastName: string;
  dni: string;
  isPending: boolean;
  phone?: string;
  address?: string;
  emergencyPhone?: string;
  healthInsurance?: string;
}

export const useUpdateUserProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId, firstName, lastName, dni, isPending, phone, address, emergencyPhone, healthInsurance }: UpdateUserProfileParams) => {
      if (isPending) {
        const { error } = await supabase
          .from("pending_members")
          .update({ first_name: firstName, last_name: lastName, dni })
          .eq("id", userId);
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from("profiles")
          .update({ 
            first_name: firstName, 
            last_name: lastName, 
            dni,
            phone: phone || null,
            address: address || null,
            emergency_phone: emergencyPhone || null,
            health_insurance: healthInsurance || null,
          })
          .eq("id", userId);
        if (error) throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      toast.success("Usuario actualizado correctamente");
    },
    onError: (error) => {
      console.error("Error updating user:", error);
      toast.error("Error al actualizar el usuario");
    },
  });
};
